import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"


export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const fadeInUpElements = document.querySelectorAll(".fadeInUp, .fadeInRight, .fadeInLeft, .fadeInBlur, .fadeInMarker");
        
        const observer = new IntersectionObserver(
        (entries) => {
        entries.forEach((entry) => {
        if (entry.isIntersecting) {
        entry.target.classList.add("on");
        }
        });
        },
        { threshold: 0.7 }
        );
        
        fadeInUpElements.forEach((el) => observer.observe(el));
        
        return () => {
            fadeInUpElements.forEach((el) => observer.unobserve(el));
        };
    }
};